(function () {
  function initLeatherGuide(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var dialog = root.querySelector('[data-swatch-dialog]');
    var dialogImage = root.querySelector('[data-dialog-image]');
    var dialogTitle = root.querySelector('[data-dialog-title]');
    var dialogSource = root.querySelector('[data-dialog-source]');
    var dialogDescription = root.querySelector('[data-dialog-description]');
    var closeButton = root.querySelector('[data-swatch-close]');
    var lastTrigger = null;

    root.querySelectorAll('[data-swatch-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        lastTrigger = button;
        dialogImage.src = button.dataset.fullImage;
        dialogImage.alt = button.dataset.name;
        dialogTitle.textContent = button.dataset.name;
        dialogSource.textContent = button.dataset.source || '';
        dialogDescription.textContent = button.dataset.description || '';
        if (typeof dialog.showModal === 'function') dialog.showModal();
      });
    });

    function closeDialog() {
      if (dialog.open) dialog.close();
    }

    closeButton.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('close', function () {
      dialogImage.src = '';
      if (lastTrigger) lastTrigger.focus();
    });

    var navLinks = Array.from(root.querySelectorAll('.oct-leathers__nav-link'));
    var families = Array.from(root.querySelectorAll('[data-leather-family]'));
    if ('IntersectionObserver' in window && navLinks.length && families.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          navLinks.forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
          });
        });
      }, { rootMargin: '-25% 0px -65% 0px' });
      families.forEach(function (family) { observer.observe(family); });
    }
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-oct-leather-guide]').forEach(initLeatherGuide);
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());